exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio input:checked ~ span[data-v-854647f8]:after {\n  position: absolute;\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  background: white;\n  border: 6px solid #56c38c;\n}", ""]);

// exports
